import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IEbayCategoryConditionResponse } from "../models/EbayOffer";

export default function useEbayConditions(categoryId: string) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60 * 60; // 1 hour

  const conditions = useQuery({
    queryKey: ["ebayConditions", categoryId],
    queryFn: () =>
      get<IEbayCategoryConditionResponse>(
        `/ebay/conditions?${categoryId ? `query=${categoryId}` : ""}`
      ).then((res) => res.data),
    enabled: !!categoryId,
    staleTime: staleTime,
    cacheTime: staleTime,
    refetchOnWindowFocus: false,
  });

  return {
    conditions,
  };
}
